import { useEffect, useMemo, useState } from 'react';

import { logDevelopmentError } from '../util/logDevelopmentError';

const replaceStartingDigits = (id: string) => id.replace(/^\d+/, 'p');

const getId = () => replaceStartingDigits(Math.random().toString(32).slice(2, 10));

type CreateElementArgs = {
  id: string;
} & Record<string, string>;

const createElement = ({ id, ...attrs }: CreateElementArgs) => {
  let el;
  try {
    el = document.createElement('div');
    el.setAttribute('id', id);
    for (const [ k, v ] of Object.entries(attrs)) {
      el.setAttribute(k, v);
    }
  } catch (error) {
    logDevelopmentError(error);
  }
  return el;
};

const usePortal = (_id: string, containerId = 'app') => {
  const id = useMemo(() => (_id != null ? _id : getId()), [ _id ]);
  const [ elSnapshot, setElSnapshot ] = useState(createElement({ id }));

  useEffect(() => {
    const container = document.getElementById(containerId);
    const parentElement = container || document.body;
    const hasElement = parentElement.querySelector<HTMLDivElement>(`#${id}`);
    const el = hasElement || createElement({ id });

    if (!hasElement && el) {
      parentElement.appendChild(el);
    }

    setElSnapshot(el);
  }, [ containerId, id ]);

  return elSnapshot;
};

export default usePortal;
